<template>
  <div class="region-change-dia">
    <common-dialog
      ref="dialog"
      title="区域切换"
      @confirm="confirm"
      :append-to-body="true"
    >
      <region-select-com
        ref="RSC"
        :mode="1"
        class="region-dia rx-3"
        :query-regions="getQueryRegion"
        @checkChange="checkChange"
        :regions="regions"
        :defExpKeys="defExpKeys"
        :defaultProps="props[0]"
      >
        <!-- <div class="text-left" slot="title">
          <el-checkbox
            class="l-h-32 m-l-19"
            :indeterminate="isIndeterminate"
            @change="checkedAll"
            v-model="checkAll"
            >{{ regions.name }}</el-checkbox
          >
        </div> -->
      </region-select-com>
    </common-dialog>
  </div>
</template>
<script>
import CommonDialog from "@/components/Dialogs/CommonDialog";
import { mapGetters } from "vuex";
import RegionSelectCom from "@/components/RegionSelectCom/RegionSelectCom";
export default {
  name: "RegionChangeDia",
  components: {
    CommonDialog,
    RegionSelectCom
  },
  props: {
    regions: {
      type: Array,
      default: []
    },
    props: {
      type: Object,
      default: () => ({
        children: [],
        label: "name",
        value: "code"
      })
    }
  },
  data() {
    return {
      checkAll: false,
      checkList: [],
      meta: [],
      isIndeterminate: false,
      queryRegions: [],
      defExpKeys: []
    };
  },
  computed: {
    getQueryRegion() {
      let arr = this.regions.children || [],
        queryRegions = [];
      this.initQueryRegions(arr, queryRegions);
      return queryRegions;
    },
    ...mapGetters(["getCurrentRegion"])
  },
  methods: {
    show() {
      this.defExpKeys = [this.getCurrentRegion.code];
      let arr = [];
      this.initQueryRegions([this.regions], arr);
      this.$refs.dialog.show();
      this.$nextTick(() => {
        this.checkAll
          ? this.$refs.RSC.setCheckedNodes(this.regions[this.props.children])
          : "";
      });
    },
    hiden() {
      this.$refs.dialog.hiden();
    },
    confirm() {
      let data = this.$refs.RSC.getCheckedNodes()[0];
      if (this.checkAll) {
        data = this.regions;
      }
      this.$emit("changeRegion", data);
    },
    setData(data) {
      return data.filter(item => {
        if (
          item[this.props.children] &&
          item[this.props.children].length != 0
        ) {
          return item;
        }
      });
    },
    checkChange(keys) {
      this.isIndeterminate = keys.length == 0 ? false : true;
      this.checkAll = false;
    },
    checkedAll(checkAll) {
      this.isIndeterminate = false;
      let data = checkAll ? this.regions[this.props.children] : [];
      this.$refs.RSC.setCheckedNodes(data);
    },
    setQueryRegions(queryRegions) {
      this.queryRegions = queryRegions;
    },
    initQueryRegions(arr, query) {
      arr.forEach(item => {
        if (item.children) {
          this.initQueryRegions(item.children, query);
        }
        query.push({ value: item.name, id: item.code });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.region-change-dia {
  .pad-15-40 {
    padding: 0.15rem 0.4rem;
  }
  .m-t-40 {
    margin-top: 0.4rem;
  }
  .l-h-32 {
    line-height: 0.32rem;
  }
  .m-l-19 {
    margin-left: 0.19rem;
  }
}
</style>
<style lang="less">
.region-dia {
  border: 1px solid #efefef;
  .title-ct {
    padding: 0.05rem;
    background-color: #f5f5f5;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/RegionChangeDia.vue